import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import { injectGlobal } from 'emotion'; // NOTE: we probably want to support `local(name)` in the src definition
// to only download the font if not available on local machine, however this
// can come with downsides regarding definitions of font weights ... so assuming
// we're serving the font from our server when using this util we're leaving
// local fonts out for now

function fontFace(_ref) {
  var _context, _context2, _context3, _context4;

  var name = _ref.name,
      src = _ref.src,
      weight = _ref.weight,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? 'normal' : _ref$style,
      _ref$display = _ref.display,
      display = _ref$display === void 0 ? 'swap' : _ref$display;
  injectGlobal(_concatInstanceProperty(_context = _concatInstanceProperty(_context2 = _concatInstanceProperty(_context3 = _concatInstanceProperty(_context4 = "\n    @font-face {\n      font-family: '".concat(name, "';\n      src: url(")).call(_context4, src, ");\n      font-weight: ")).call(_context3, weight, ";\n      font-style: ")).call(_context2, style, ";\n      font-display: ")).call(_context, display, ";\n    }\n  "));
}

export default fontFace;